const TOKEN_KEY = 'token';
const USER_KEY = 'user';

const isBrowser = typeof window !== 'undefined';

export const getToken = () => {
  if (!isBrowser) {
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string) => {
  if (!isBrowser) {
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearToken = () => {
  if (!isBrowser) {
    return;
  }
  localStorage.removeItem(TOKEN_KEY);
};

export const getStoredUser = () => {
  if (!isBrowser) {
    return undefined;
  }
  const rawUser = localStorage.getItem(USER_KEY);
  if (!rawUser) {
    return undefined;
  }
  try {
    return JSON.parse(rawUser) as API.AuthUser;
  } catch {
    return undefined;
  }
};

export const setStoredUser = (user: API.AuthUser) => {
  if (!isBrowser) {
    return;
  }
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearStoredUser = () => {
  if (!isBrowser) {
    return;
  }
  localStorage.removeItem(USER_KEY);
};

export const clearAuth = () => {
  clearToken();
  clearStoredUser();
};

export const mapUserToCurrentUser = (user?: API.AuthUser) => {
  if (!user) {
    return undefined;
  }
  return {
    userid: user.id,
    name: user.name ?? user.username,
    email: user.email,
  } as API.CurrentUser;
};
